(() => {
  if (customElements.get('eg-audi-fitment')) return;
  let sequence = 0;
  class AudiFitment extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const button = this.querySelector('button'), template = this.querySelector('template');
      if (!button || !template || typeof HTMLDialogElement === 'undefined') return;
      this.ready = true;
      button.hidden = false;
      button.addEventListener('click', event => {
        event.preventDefault(); event.stopPropagation();
        if (this.dialog?.open) return;
        const dialog = document.createElement('dialog');
        dialog.className = 'eg-af-dialog';
        const close = document.createElement('button');
        close.type = 'button'; close.className = 'eg-af-close'; close.textContent = '×';
        close.setAttribute('aria-label', 'Close fitment details');
        const content = document.createElement('div'); content.className = 'eg-af-content';
        content.append(template.content.cloneNode(true));
        const title = content.querySelector('[data-eg-af-title]');
        title.id = 'eg-af-heading-' + (++sequence);
        dialog.setAttribute('aria-labelledby', title.id);
        dialog.append(close, content); document.body.append(dialog); this.dialog = dialog;
        const overflow = document.body.style.overflow;
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', e => {
          const r = dialog.getBoundingClientRect();
          if (e.target === dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.body.style.overflow = overflow; dialog.remove(); this.dialog = null;
          if (button.isConnected) button.focus({preventScroll:true});
        }, {once:true});
        dialog.showModal(); document.body.style.overflow = 'hidden'; close.focus({preventScroll:true});
      });
    }
    disconnectedCallback() { if (this.dialog?.open) this.dialog.close(); }
  }
  customElements.define('eg-audi-fitment', AudiFitment);
})();
